/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type CommodityDetail = 'Undefined' | 'ElectricityCustomer' | 'GasCustomer' | 'HeatCustomer' | 'ElectricitySupplier' | 'GasSupplier' | 'eMobility' | 'CNG' | 'Other';

export const CommodityDetail = {
    Undefined: 'Undefined' as CommodityDetail,
    ElectricityCustomer: 'ElectricityCustomer' as CommodityDetail,
    GasCustomer: 'GasCustomer' as CommodityDetail,
    HeatCustomer: 'HeatCustomer' as CommodityDetail,
    ElectricitySupplier: 'ElectricitySupplier' as CommodityDetail,
    GasSupplier: 'GasSupplier' as CommodityDetail,
    eMobility: 'eMobility' as CommodityDetail,
    CNG: 'CNG' as CommodityDetail,
    Other: 'Other' as CommodityDetail
};